<ng-container *ngIf="message">
  <div class="notice">
    {{ message }}
  </div>
</ng-container>
